module.exports = __webpack_public_path__ + "media/images/flags/pl-433e6592594c362510816cfb73b37074.svg";